export enum actionTypes {
  SUBAREAS_FETCH = 'SUBAREAS_FETCH',
  SUBAREAS_SUCCESS = 'SUBAREAS_SUCCESS',
  SUBAREAS_ERROR = 'SUBAREAS_ERROR',
  SUBAREAS_RESET = 'SUBAREAS_RESET',
}

export enum SubAreasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface SubArea {
  id: number
  nombre: string
}

export interface SubAreasState {
  idArea?: number
  status: SubAreasStatus
  subAreas: Array<SubArea>
}

export interface SubAreasFetch {
  type: typeof actionTypes.SUBAREAS_FETCH
  payload: { idArea }
}

export interface SubAreasSuccess {
  type: typeof actionTypes.SUBAREAS_SUCCESS
  payload: { subAreas }
}

export interface SubAreasError {
  type: typeof actionTypes.SUBAREAS_ERROR
  payload: null
}

export interface SubAreasReset {
  type: typeof actionTypes.SUBAREAS_RESET
  payload: null
}

export type SubAreasActions = SubAreasFetch | SubAreasSuccess | SubAreasError | SubAreasReset

export const initialState: SubAreasState = {
  status: SubAreasStatus.Idle,
  subAreas: [],
}
